import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useRef } from 'react';

type FocusManagerCallbacks = {
  onFocus?: () => void;
  onRefocus?: () => void;
  onBlur?: () => void;
};

export const useFocusManager = ({
  onFocus,
  onRefocus,
  onBlur,
}: FocusManagerCallbacks) => {
  let { current: isRefocus } = useRef(false);

  useFocusEffect(
    useCallback(() => {
      if (isRefocus) {
        onRefocus?.();
      } else {
        onFocus?.();
      }

      return () => {
        isRefocus = true;
        onBlur?.();
      };
    }, [])
  );
};
